import {
  FaAddressCard,
  FaEnvelope,
  FaHome,
  FaInfoCircle,
  FaSignOutAlt,
  FaCircle,
  FaPlusCircle,
  FaSearch,
  FaJournalWhills,
} from "react-icons/fa";
import { CNavBarItemT } from "./navigationType";
import ManageJournals from "src/pages/ManageJournals.tsx";
import PublicationList from "src/components/PublicationList";
import ChangePasswordPage from "src/pages/components/ChangePassword";
import AddPublication from "src/pages/components/AddPublication";
import SearchReviewer from "src/pages/components/SearchReviewer";
import SearchResearchPaper from "src/pages/components/SearchResearchPaper";
import PublishRequests from "src/components/PublishRequests";
import ReviewerRequestsList from "src/pages/components/ReviewerRequestsList";
import CreateJournalPage from "src/pages/CreateJournalPage";
import JoinedReviewers from "src/pages/components/JoinedReviewers";

export const PublisherNavbar: CNavBarItemT[] = [
  {
    label: "Journals",
    href: "/",
    icon: <FaHome className="custom-icon" />,
    component: ManageJournals,
  },
  {
    label: "Create Journal",
    href: "/create-journal",
    icon: <FaPlusCircle className="custom-icon" />,
    component: CreateJournalPage,
  },
  {
    label: "Search Research Paper",
    href: "/search-research-paper",
    icon: <FaSearch className="custom-icon" />,
    component: SearchResearchPaper,
  },
  {
    label: "Publish Requests",
    href: "/publish-requests",
    icon: <FaEnvelope className="custom-icon" />,
    component: PublishRequests,
  },
  {
    label: "Search Reviewer",
    href: "/search-reviewer",
    icon: <FaSearch className="custom-icon" />,
    component: SearchReviewer,
  },
  {
    label: "Joined Reviewer",
    href: "/joined-reviewer",
    icon: <FaJournalWhills className="custom-icon" />,
    component: JoinedReviewers,
  },
  {
    label: "Reviewers Requests",
    href: "/reviewer-requests",
    icon: <i className="fa fa-tasks custom-icon" />,
    component: ReviewerRequestsList,
  },
  {
    label: "Add Publications",
    href: "/add-publication",
    icon: <FaPlusCircle className="custom-icon" />,
    component: AddPublication,
  },
  {
    label: "Publication List",
    href: "/publication-list",
    icon: <FaEnvelope className="custom-icon" />,
    component: PublicationList,
  },
  {
    label: "Change Password",
    href: "/change-password",
    icon: <FaCircle className="custom-icon" />,
    component: ChangePasswordPage,
  },
  {
    label: "Logout",
    href: "/",
    icon: <FaSignOutAlt className="custom-icon" />,
    onClick(dispatch) {},
  },
];
